'use strict';

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var classNames = require('classnames');
require('prop-types');
var React = require('react');
var AlternateButtonWithPlus = require('./AlternateButtonWithPlus.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    button: {
      borderRadius: 8,
      border: '1px solid #D8D8D8',
      padding: '10px 16px',
      height: '100%',
      '&.alternate-button-selected, &:hover.alternate-button-selected': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main
      },
      textTransform: 'none',
      fontSize: 16,
      color: theme.palette.secondary.light,
      '&:hover': {
        color: theme.palette.black.primary
      }
    }
  };
};

var AlternateButton = function AlternateButton(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      icon = _ref.icon,
      onClick = _ref.onClick,
      selected = _ref.selected,
      rest = objectWithoutProperties(_ref, ["classes", "title", "icon", "onClick", "selected"]);

  if (title || icon) {
    return React__default["default"].createElement(AlternateButtonWithPlus, {
      title: title,
      icon: icon,
      onClick: onClick
    });
  }

  var button = classes.button,
      overriddenClasses = objectWithoutProperties(classes, ["button"]);

  return React__default["default"].createElement(Button["default"], _extends["default"]({
    className: classNames__default["default"](button, {
      'alternate-button-selected': selected
    }),
    classes: overriddenClasses,
    onClick: onClick,
    fullWidth: true
  }, rest));
};

AlternateButton.defaultProps = {
  onClick: function onClick() {},
  variant: 'outlined',
  color: 'primary'
};
var AlternateButton$1 = withStyles(styles)(AlternateButton);

module.exports = AlternateButton$1;
